<script lang="ts">
  interface InfiniteScrollProps {
    reachedBottom: boolean;
  }

  let infiniteScroll: HTMLElement;
  let { reachedBottom = $bindable(false) }: InfiniteScrollProps = $props();

  function parseScroll(): void {
    const scrollableHeight = infiniteScroll.scrollHeight - infiniteScroll.clientHeight;
    const scrollTop = infiniteScroll.scrollTop;

    if(scrollTop === 0) {
      reachedBottom = false;
      return;
    }

    reachedBottom = scrollTop >= scrollableHeight - 20;
  }
</script>

<div class="infinite-scroll" bind:this={ infiniteScroll } onscroll={ parseScroll }>
  <slot></slot>
</div>
